export function getEmployeeFrequentFlyerCode(
  program: string,
  employee?: App.BusinessTraveller.EmployeeFromMeEndpoint,
): string {
  if (!employee?.employeeFrequentFlyer) {
    return ''
  }

  const frequentFlyer = employee.employeeFrequentFlyer.find(
    (ff) => ff.program === program,
  )

  return frequentFlyer ? frequentFlyer.memberNumber : ''
}

export function getFrequentFlyerCheckoutFields(
  employee: App.BusinessTraveller.EmployeeFromMeEndpoint | undefined,
  flightItems: Array<App.Checkout.FlightItem>,
): Record<string, string> {
  if (!employee) {
    return {}
  }

  const qantasFrequentFlyer = getEmployeeFrequentFlyerCode('qantas', employee)
  const velocityFrequentFlyer = getEmployeeFrequentFlyerCode('velocity', employee)

  // Carriers a programme's number can be attached to. Qantas covers Qantas and
  // its Jetstar partner; Velocity covers Virgin Australia only.
  const QANTAS_CARRIERS = ['QF', 'JQ']
  const VELOCITY_CARRIERS = ['VA']

  const formFields = flightItems.flatMap((item) => item.flights)
    .reduce((fields, flight, index) => {
      if (QANTAS_CARRIERS.includes(flight.carrier) && qantasFrequentFlyer) {
        return {
          ...fields,
          [`frequentFlyerAirline${index + 1}`]: 'QF',
          [`frequentFlyerNumber${index + 1}`]: qantasFrequentFlyer,
        }
      }

      if (VELOCITY_CARRIERS.includes(flight.carrier) && velocityFrequentFlyer) {
        return {
          ...fields,
          [`frequentFlyerAirline${index + 1}`]: 'VA',
          [`frequentFlyerNumber${index + 1}`]: velocityFrequentFlyer,
        }
      }

      return { ...fields }
    }, {})

  return {
    qantasFrequentFlyerNo: qantasFrequentFlyer,
    velocityFrequentFlyerNo: velocityFrequentFlyer,
    ...formFields,
  }
}
